import * as React from "react";
import Link from "gatsby-link";
import {useState} from "react";
import {NavItem} from "./NavItem";
import {useNav} from "../hooks/useNav";

export const Header = ({lang , path ,alternativePath}) =>{

  const langChange = {
    text : lang==="en"? "fr" : "en",
    to:alternativePath
  }

const {menu,slugTranslate ,menuTranslate} = useNav(lang);

  const navOrder = {
    home:1,
    projects:2,
    expertises:3,
    contact:4,
  }

  const nav = [];
  for(let menuItem in menu) {
      const item = {
        text : menuTranslate(menuItem),
        to:`/${lang}/${ slugTranslate(menuItem)}`,
        order: navOrder[menuItem]||  100
      }
      if(menuItem==='contact'){
        item.to=`./#${ slugTranslate(menuItem)}`
      }
      if(menuItem==='projects'){
        item.to=`/${lang}/${ slugTranslate('home')}/#${ slugTranslate(menuItem)}`
      }
    nav.push(item);
    }

   nav.sort((a,b)=>{
    return a.order - b.order
  })



    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <>
            <div className="header-place"/>
            <header className={"header" + (menuOpen ? " nav-open " : "")} >
                <div className="container">
                    <div className="header__content">
                        <div className="header__logo">
                            <Link to={"/"+lang+"/"+slugTranslate('home') } title="20k logo">
                                <svg x="0px" y="0px" viewBox="230 320 550 300">
                                    <path
                                        d="M298.6,555.3h96.9v45.3H249.3v-45.3c0-66.3,98-60.1,98-95.2c0-9.6-7.4-18.1-22.1-18.1 c-15.9,0-27.8,7.4-27.8,19.8h-48.2c0-36.3,34.6-65.2,76.5-65.2c39.1,0,69.7,24.9,69.7,65.2C395.5,529.5, 298.6,522.7,298.6,555.3"/>
                                    <path
                                        d="M597.5,472.5v55c0,51.9-41.1,75.9-81.6,75.9c-40.5,0-81.6-24.1-81.6-75.9v-55c0-51.9,41.1-75.9,81.6-75.9 C556.4,396.6,597.5,420.7,597.5,472.5 M549.3,527.5v-55c0-20.4-15.9-30.6-33.4-30.6c-17.6,0-33.4,10.2-33.4,30.6v55 c0,20.4,15.9,30.6,33.4,30.6C533.4,558.1,549.3,547.9,549.3,527.5"/>
                                    <polygon
                                        points="697.1,467.1 746.3,538.2 710.5,538.2 676.8,490 666.4,501.8 666.4,538.2 636,538.2 636,411 666.4,411 666.4,457.2 707.1,411 746.3,411"/>
                                    <rect x="636" y="576.1" width="114.7" height="27.3"/>
                                </svg>
                            </Link>
                        </div>

                        <nav className="nav">
                            <ul id="menu" className="nav-menu__wrap">
                                {nav.map((item , i )=>{
                                    return <NavItem setMenuOpen={setMenuOpen} key={i} text={item.text} to={item.to} path={path}/>
                                })}
                              <NavItem  style={{textTransform:"uppercase"}} text={langChange.text} to={langChange.to} />

                            </ul>
                        </nav>
                    </div>
                    <button onClick={()=>{setMenuOpen(!menuOpen)}} aria-labelledby="menu button" type="button" aria-label="open menu" title="menu button"
                            className="nav__btn">
                        <span className="nav__btn_row"/>
                        <span className="nav__btn_row"/>
                        <span className="nav__btn_row"/>
                    </button>
                </div>
            </header>
        </>

    )
}
